import { render, staticRenderFns } from "./Workload.vue?vue&type=template&id=72f1f0e5"
import script from "./Workload.vue?vue&type=script&lang=js"
export * from "./Workload.vue?vue&type=script&lang=js"
import style0 from "./Workload.vue?vue&type=style&index=0&id=72f1f0e5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../.yarn/__virtual__/vue-loader-virtual-f8ff0a7f65/4/.yarn/berry/cache/vue-loader-npm-15.11.1-829412283a-10c0.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports